/**
 * zoorix-cart-drawer-fix.js
 * ---------------------------------------------------------------------------
 * Ouvre le slide cart NATIF du thème (cart-drawer-component) après n'importe
 * quel ajout au panier — y compris le bouton "Sticky Add to Cart" de Zoorix,
 * qui appelle directement l'API Shopify (/cart/add) sans déclencher
 * l'événement "cart:update" attendu par le thème.
 *
 * Principe :
 *   1. On intercepte les requêtes d'ajout au panier (fetch ET XHR) vers /cart/add.
 *   2. Après un ajout réussi, on récupère le HTML à jour des sections du panier
 *      (Section Rendering API), puis on émet "cart:update" AVEC ces sections :
 *      le thème morphe immédiatement le contenu. On ouvre le drawer ENSUITE,
 *      déjà rempli -> plus de flash "panier vide".
 *   3. Dédup : si le formulaire produit natif du thème vient déjà de gérer
 *      l'ajout (source "product-form-component"), on ne fait rien.
 *
 * 100% additif et réversible. Tout est enveloppé dans des try/catch pour ne
 * JAMAIS bloquer l'ajout au panier.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var ADD_PATH = '/cart/add';
  var DEDUP_MS = 2000;
  var nativeHandledAt = 0;
  var busy = false;

  // Repère les ajouts gérés nativement par le thème pour ne pas les doubler.
  try {
    document.addEventListener('cart:update', function (e) {
      try {
        var src = e && e.detail && e.detail.data && e.detail.data.source;
        if (src === 'product-form-component') nativeHandledAt = Date.now();
      } catch (err) {}
    });
  } catch (err) {}

  function isAddUrl(url) {
    return typeof url === 'string' && url.indexOf(ADD_PATH) !== -1;
  }

  function cartSectionIds() {
    var ids = [];
    try {
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        var id = el.getAttribute('data-section-id');
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
    } catch (e) {}
    return ids;
  }

  function openDrawer() {
    try {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    } catch (e) {}
  }

  function dispatchCartUpdate(sections) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: {},
          sourceId: 'zoorix-sticky-atc',
          data: { source: 'zoorix-sticky-atc', sections: sections || undefined }
        }
      })
    );
  }

  function handleAdd() {
    try {
      if (busy) return;
      // Le thème a déjà géré cet ajout (formulaire produit natif) -> on s'abstient.
      if (Date.now() - nativeHandledAt < DEDUP_MS) return;
      busy = true;

      var ids = cartSectionIds();
      var done = function (sections) {
        try { dispatchCartUpdate(sections); } catch (e) {}
        // Le morph est synchrone : à l'ouverture, le contenu est déjà à jour.
        openDrawer();
        busy = false;
      };

      if (!ids.length) { done(null); return; }

      // Section Rendering API sur la page courante (la section du drawer y existe).
      var url = window.location.pathname + '?sections=' + encodeURIComponent(ids.join(','));
      fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (sections) { done(sections); })
        .catch(function () { done(null); });
    } catch (err) {
      busy = false;
      if (window.console && console.warn) console.warn('[zoorix-cart-drawer-fix]', err);
    }
  }

  // --- Interception des ajouts via fetch -----------------------------------
  try {
    if (typeof window.fetch === 'function') {
      var origFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var url;
        try {
          url = args[0] && typeof args[0] === 'object' ? args[0].url : args[0];
        } catch (e) {}
        var promise = origFetch.apply(this, args);
        try {
          if (isAddUrl(url) && promise && typeof promise.then === 'function') {
            promise.then(function (resp) {
              try {
                if (resp && (resp.ok || resp.status === 200)) {
                  setTimeout(handleAdd, 60);
              }
              } catch (e) {}
            }).catch(function () {});
          }
        } catch (e) {}
        return promise;
      };
    }
  } catch (err) {}

  // --- Interception des ajouts via XMLHttpRequest -------------------------
  try {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__zrxIsAdd = isAddUrl(url); } catch (e) {}
      return origOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      try {
        if (this.__zrxIsAdd) {
          this.addEventListener('load', function () {
            try {
              if (this.status >= 200 && this.status < 300) {
                setTimeout(handleAdd, 60);
              }
            } catch (e) {}
          });
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  } catch (err) {}
})();
